import React, { useState } from "react";

const SizeSelector = ({ sizes }) => {
  const [selectedSize, setSelectedSize] = useState("S");

  return (
    <div className="flex gap-2 mt-3 justify-start">
      {sizes.map((size, index) => (
        <div
          key={index}
          className={`p-4 flex items-center justify-center cursor-pointer ${
            selectedSize === size
              ? "bg-[#A0DFE7] opacity-100"
              : "bg-[#ECF7F8] opacity-100"
          } transition-all duration-300 rounded-xl `}
          style={
            size.available === false
              ? {
                  textDecorationLine: "line-through",
                  textDecorationColor: "red",
                  textDecorationThickness: "3px",
                  cursor: "not-allowed",
                  opacity: 0.5,
                }
              : {}
          }
          onClick={() => {
            if (size.available) {
              setSelectedSize(size);
            }
          }}
        >
          <span
            className={`text-xs text-black font-semibold ${
              selectedSize === size ? "opacity-100" : "opacity-100"
            }`}
          >
            {size.size}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SizeSelector;
